import {db} from "../services/db";
import firebase from 'firebase/app'
import 'firebase/storage'

export const user = {
    namespaced: true,
    state: {
    // from authentication document
        uid: '',
        id: '',
        thirdPartyName: '',
        email: '',
        emailVerified: true,
    // from app data document
        firstName: '',
        lastName: '',
        userName: '',
        language: '',
        showFullName: true,
        image: {
            url: '',
            urlMin: '',
            crop: '',
        },
        search: {},
        permissions: {},
    // textkeys
        i18n: {
            firstName: 'user.firstName',
            lastName: 'user.lastName',
            userName: 'user.userName',
            image: 'user.profileImage',
            showFullName: 'user.showFullName',
            language: {
                label: 'basic.language',
                selection: [{value: 'de', i18n: 'basic.german'}, {value: 'en', i18n: 'basic.english'}]
            }
        },
    },
    mutations: {
    // module specific
        setFromAuthentication (state, authUser) {
            state.id = authUser.uid;
            state.uid = authUser.uid;
            state.thirdPartyName = authUser.displayName;
            state.email = authUser.email;
            //state.emailVerified = authUser.emailVerified;
        },
        setFromAppData(state, userObj){
            Object.keys(userObj).forEach(e => {
                state[e] = userObj[e];
            });
        },
        emailVerified (state) {
            console.log ("commit emailVerified");
            state.emailVerified = true;
        },
        logout (state) {
            state.id = '';
            state.uid = '';
            state.thirdPartyName = '';
            state.email = '';
            state.permissions = {};
            //state.emailVerified = false;
        }
    },
    actions: {
    // must have in all modules
        async beforeParameterChange(context, params) {
        // action depends on parameter, save profile images only when image is changed
            if (params.parameter === 'userName') {
                let funcPath = context.rootState.config.cloud.funcPath;
                let http = funcPath + 'checkUserName?userName=' + params.newValue;
                await fetch(http)
                    .then(response => response.json())
                    .then(existing => { if ( existing ) {
                        throw new Error( 'Dieser Benutzername ist leider schon vergeben!' ) } });
                return;
            } else if (params.parameter === 'language') {
                //i18n.locale = params.newValue;
                return;
            } else if (params.parameter !== 'image') {
                return;
            }
        // upload or delete original size image
            params.imageSizeExtension = '';
            await context.dispatch('uploadImage', params );
        // upload or delete original min size image
            params.imageSizeExtension = 'Min';
            await context.dispatch('uploadImage', params );
        },
    // upload or delete image
        async uploadImage(context, params){
            const imageParameterForUrl = "url" + params.imageSizeExtension;                         // user/image/url or user/image/urlMin => parameter in the image map in the user document
            const imageName = 'user/' + params.object.id + params.imageSizeExtension + '.jpeg';     // path of the image file in the firebase cloud storage
            const firebaseRef = firebase.storage().ref();
            const sourcePath = context.rootState.config.storage.user;                               // path to the image file without filename (for src in img-tag)
        // do something if image was changed
            if ( context.state.image[imageParameterForUrl] !== params.newValue[imageParameterForUrl] ) {
                if (params.newValue[imageParameterForUrl] !== '') {
            // add new image or replace existing image
                // write new image to storage (from string)
                    await firebaseRef.child(imageName).putString(params.newValue[imageParameterForUrl], 'data_url');
                // get downloadUrl from new image in storage
                    let url = await firebaseRef.child(imageName).getDownloadURL();
                // save downloadUrl without path (only image file name + token)
                    params.newValue[imageParameterForUrl] = url.replace(sourcePath, '');
                } else {
            // delete existing image
                    await firebaseRef.child(imageName).delete();
                }
            }
        }
    },
    getters: {
    // must have in all modules
        getDBDocument:() => (id) => {
            return db.collection("users").doc(id);
        },
    // optional getters
        fullname (state) {
            return state.firstName + " " + state.lastName;
        },
        getPublicData(state){
            const publicData = {
                id: state.uid,
                urlMin: state.image.urlMin,
                userName: state.userName
            };
            if ( state.showFullName ) {
                publicData.firstName = state.firstName;
                publicData.lastName = state.lastName;
            }
            return publicData;
        },
    // authorization getters
        isMeisterschaftAdmin: (state) => (landesverbandId) => {
            return state.permissions?.ergebnisdienst ||
                state.permissions?.['sportobmann_' + landesverbandId] ||
                state.permissions?.['meisterschaftAdmin_' + landesverbandId]
        },
        isMeisterschaftOperator: (state) => (landesverbandId) => {
            return state.permissions?.ergebnisdienst ||
                state.permissions?.['sportobmann_' + landesverbandId] ||
                state.permissions?.['meisterschaftAdmin_' + landesverbandId] ||
                state.permissions?.['meisterschaftOperator_' + landesverbandId]
        }
    }
}